import clsx from "clsx"
import { ComponentProps, PropsWithChildren } from "react"
import { tv } from "tailwind-variants"

const variants = tv({
  base: "relative",
  variants: {
    variant: {
      "1": "h-1",
      "2": "h-2",
      "3": "h-3",
      "4": "h-4",
      "5": "h-5",
      "6": "h-6",
      "7": "h-7",
      "8": "h-8",
    },
    admin: {
      true: "bg-glass border border-dotted border-grey-dark flex justify-center items-center",
    },
  },
  defaultVariants: {
    variant: "4",
    admin: false,
  },
})

type Props = ComponentProps<"div"> & {
  size?: keyof typeof variants.variants.variant
}

export function Spacer(props: Props) {
  return (
    <div {...props} className={clsx(variants({ variant: props.size, admin: env.admin }), props.className)}>
      {env.admin && (
        <span className="text-grey-mid text-sm absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">{`Spacer ${props.size}`}</span>
      )}
    </div>
  )
}
